import { LayoutHOC } from "base/ui/layout/layout";
import createDeliveryRate from "./DeliveryRate";
import createDeliveryResult from "./DeliveryResult";
import createEmailSendingResult from "./EmailSendingResult";
import createListRegistration from "./ListRigistration";
import createReceivingSchedule from "./ReceivingSchedule";
import createWasteScrapSummary from "./WasteScrapSummary";
import { reportRoutes } from "./routes";
import createListRegistrationWaste from './ListRigistrationWaste';
import createTongHopKhoiLuongChatThaiNguyHai from './TongHopKhoiLuongChatThaiNguyHai';
import createChatThaiCongNghiep from './ChatThaiCongNghiep';

export const createReportPage = (layoutHOC: LayoutHOC) => {
  // Báo cáo danh sách đăng ký xe
  const RegistrationList = createListRegistration()
  // Báo cáo kết quả giao hàng
  const DeliveryResult = createDeliveryResult()
  // báo cáo tỷ lệ giáo hàng đúng hẹn
  const DeliveryRate = createDeliveryRate()
  // Receiving schedule of BHF
  const ReceivingSchedule = createReceivingSchedule()
  // Waste & Scrap Summary
  const WasteScrapSummary = createWasteScrapSummary()
  //Báo cáo kêt quả gửi email
  const EmailSendingResult = createEmailSendingResult();

  // BC05 Báo cáo danh sách xe giao hàng
  const RegistrationListWaste = createListRegistrationWaste()

  // báo cáo tổng hợp khối lượng chất thải nguy hại
  const TongHopKhoiLuongChatThaiNguyHai = createTongHopKhoiLuongChatThaiNguyHai();

  // báo cáo tổng hợp khối lượng chất thải công nghiệp thông thường
  const ChatThaiCongNghiep = createChatThaiCongNghiep();

  const ReportPage = layoutHOC(reportRoutes);

  return () => (
    <ReportPage
      RegistrationList={RegistrationList}
      DeliveryResult={DeliveryResult}
      DeliveryRate={DeliveryRate}
      ReceivingSchedule={ReceivingSchedule}
      EmailSendingResult={EmailSendingResult}
      WasteScrapSummary={WasteScrapSummary}
      RegistrationListWaste={RegistrationListWaste}
      TongHopKhoiLuongChatThaiNguyHai={TongHopKhoiLuongChatThaiNguyHai}
      ChatThaiCongNghiep={ChatThaiCongNghiep}
    />
  );
};